/**
 * 产品信息 API
 * @module core/api/product
 */

import type { HttpClient } from '../http/HttpClient'
import type { ProductInfo } from '../../types/product'
import { API_ENDPOINTS } from '../../constants/api-endpoints'
import { getSoftId } from '../config/SDKConfigManager'

export class ProductAPI {
  constructor(private httpClient: HttpClient) {}

  /** 获取产品信息 */
  async getProductInfo(): Promise<ProductInfo> {
    const softId = getSoftId()
    const response = await this.httpClient.get<{ data: ProductInfo }>(
      `${API_ENDPOINTS.PRODUCT.INFO}/${encodeURIComponent(softId)}`
    )
    return response.data.data
  }
}
